const ENCODED_FILENAME = /filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i;
const PLAIN_FILENAME = /filename\s*=\s*(?:"([^"]+)"|([^;]+))/i;

function sanitiseFilename(raw: string): string | null {
  const cleaned = raw.trim().replace(/[\\/]/g, '_');
  return cleaned.length > 0 ? cleaned : null;
}

function decodeEncodedFilename(header: string): string | null {
  const match = ENCODED_FILENAME.exec(header);
  if (!match) return null;
  try {
    return sanitiseFilename(decodeURIComponent(match[1]));
  } catch {
    return null;
  }
}

export function parseContentDispositionFilename(header: string | null): string | null {
  if (!header) return null;
  const encoded = decodeEncodedFilename(header);
  if (encoded) return encoded;
  const plain = PLAIN_FILENAME.exec(header);
  return plain ? sanitiseFilename(plain[1] ?? plain[2]) : null;
}

export function exportFallbackFilename(createdAt: string): string {
  const created = new Date(createdAt);
  if (Number.isNaN(created.getTime())) return 'demand-report.xlsx';
  const pad = (value: number): string => value.toString().padStart(2, '0');
  const day = `${created.getFullYear()}${pad(created.getMonth() + 1)}${pad(created.getDate())}`;
  const time = `${pad(created.getHours())}${pad(created.getMinutes())}${pad(created.getSeconds())}`;
  return `demand-report-${day}-${time}.xlsx`;
}

export function saveBlobAsFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
